import Axios from '../axios'

export function fetchGgMenuScriptUrl() {
  return Axios.get('/api/v1/gg_menu/script_url')
}

export function fetchGgMenuData() {
  return Axios.get('/api/v1/gg_menu/data')
}

export function loadGgMenuScript() {
  if (document.getElementById('gg-menu-script')) { return }

  fetchGgMenuScriptUrl()
    .then(response => {
      const scriptUrl = response.data?.url || response.data
      const script = document.createElement('script')
      script.id = 'gg-menu-script'
      script.src = scriptUrl
      document.head.appendChild(script)
    })
    .catch(err => console.error('Failed to load GG menu script', err))
}
